/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { SubPage, Group, Copy, Title, CTAs, Link, Button, ListTable, EmptyState } from '@insticator/insticator-ui'; // iui-material
import EditUser from 'pages/dashboard/account/users/edituser/edituser_container';
import AddUser from 'pages/dashboard/account/users/adduser/adduser_container';
import DeleteUser from 'pages/dashboard/account/users/deleteuser/deleteuser_container';
//styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/users/users_styles';

//[{"userUUID":"6ad7d870-f91e-4f2f-a3cc-6d2cb9728fe9","firstName":"Vlad","lastName":"Deev","email":"vlad@aefaefa.com","phoneNumber":"(212) 225-2213","userStatus":"INVITE_SENT","permissions":["settings.paymentInfo","settings.general","settings.adsTxt","manageEmbeds"]},{"userUUID":"173ad632-88bc-4b73-b775-3f5305c2a9f3","firstName":"Jonathan","lastName":"Aquino","email":"jonathanaquino@insticator.com","phoneNumber":"(646) 204-3782","userStatus":"ACTIVATED","permissions":["setttings.sites","settings.paymentInfo","settings.users","settings.agreement","settings.general","settings.adsTxt","manageEmbeds"]},{"userUUID":"ca95fa53-d8fa-4c30-a4db-13120436b5f7","firstName":"George","lastName":"Jefferson","email":"bigJeff@gmail.com","phoneNumber":"(212) 225-2213","userStatus":"INVITE_SENT","permissions":["settings.paymentInfo","settings.general","settings.adsTxt","manageEmbeds"]}]



/* ========== ~~~~~~~~~~ ACCOUNT USERS ~~~~~~~~~~ ========== */
class Users extends Component {
    componentDidMount(){
        this.props.getUsers(this.props.accountUUID)
    }
    handleTableData = () => {
        let dataArray = [];
        this.props.users.map((item, index) => {
            let disable = item.userUUID === this.props.userUUID;
            return dataArray.push({
                name: item.firstName, email: <Link type={`email`} text={item.email} color={`primary`} action={`mailto:${item.email}`} />,
                edit: (
                    <div className={`editcolumn`} >
                        {(item.userStatus === 'CREATED' && this.props.mocked) && <Button type={'action'} text={'Invite User'} operation={'send'} processing={this.props.sendingInvite} color={'primary'} removeLoaderIcon={true} action={()=>this.props.sendInvite(item.userUUID)} />}
                        <Link type={`modal`} disabled={disable} text={`Edit`} color={`primary`} icon={`pencil-alt`} action={<EditUser index={index} userInfo={item}/>} />
                        <Link type={`modal`} text={`Delete`} disabled={disable} color={`primary`} icon={`trash-alt`} action={<DeleteUser email={item.email} index={index} userUUID={item.userUUID} name={`${item.firstName} ${item.lastName}`}/>} />
                    </div>),
                status: item.userStatus.split('_').join(' ') })
        });
        return dataArray;
    };
    redirectToUsersV2 = () => {
        window.open(`https://publisher-portal.${url.baseURL}/dashboard/settings/users`, '_self')
    }
    render() {
        return(
            <SubPage name={`users`} klass={`users ${this.props.classes.users}`}>
                {/* <Copy name={`page-copy`}>
                    <Title variant={'withctas'}>
                        <h2>Users</h2>
                        <Group name={`controls`}>
                            <CTAs>
                                <Button type={'modal'} action={<AddUser/>} variant={`primary`} name={`add_user`} text={`Add User`} />
                            </CTAs>
                        </Group>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <ListTable
                        name={`users`}
                        type={`fixed-column`}
                        fixedColWidth={150}
                        size={`full`}
                        columnHeads={{ name: 'Name', email: 'Email', status: 'Status', edit: '' }}
                        data={this.handleTableData()}
                        rowsPerPage={'general'}
                        paginationLocation={`bottom`}
                    />
                </Group> */}
                <EmptyState 
                    graphicName={'error-404'} 
                    buttonText={'Go to Users Management'} 
                    bodycopy={<p>Users Management has been moved to <b>Publisher Portal V2 (Beta)</b></p>} 
                    buttonClick={() => this.redirectToUsersV2()} 
                    buttonName={'gotoppv2users'}
                />
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// export default Users;
export default injectSheet(styles)(Users);
